import { formatMoney } from '@shopify/theme-currency';
const buyNowPayLater = () => {
    document.addEventListener('variant:change', (event) => {
        const variant = event.detail.variant;
        const price = variant.price;
        let bnplPrice = price / 4;
        bnplPrice = formatMoney(bnplPrice, window.themeVariables.settings.moneyFormat);
        const bnplString = `4 x ${bnplPrice}`;
        const bnplPriceContainers = document.querySelectorAll('[data-bnpl-container]');
        bnplPriceContainers.forEach((container) => {
            container.innerHTML = bnplString + '&nbsp;';
        });
    });
};
export { buyNowPayLater };
